// prettier-ignore
import * as React from 'react'

import { CollectionView } from './Collection.view'

export const Collection = () => {
  return <CollectionView />
}
